<template>
  <div class="home">
    <div class="gr">
      <ul class="game_type" >
          <li @click="sideMenusIndex = -1" :class="{ on: sideMenusIndex == -1 }"><img
              src="~@/img/home.png" /><span>大厅</span>
          </li>
          <li v-for="(o, index) in sideMenus" :key="o.gametype" @click="sideMenusIndex = index;currentIndexGameType=-1;qeuryAllGameListByGameTypeAsync(o.gametype);currentPlat=''"
            :class="{ on: index == sideMenusIndex }"><img :src="o.gamePicUrl + o.gamePicUrl_Path + o.picName" /><span>{{
              o.name }}</span></li>
      </ul>
    </div>
    <div class="banner">
      <div class="m-banner">
          <van-swipe class="my-swipe" :autoplay="3000"  indicator-color="white" :show-indicators="false"  @change="onSwipeChange" >
            <van-swipe-item v-for="o in banners" :key="o.id"><img
                :src="o.picUrl + '/img/promopics/app' + '/' + o.picBanner"></van-swipe-item>
          </van-swipe>
          <div class="next">
            <span></span>
            <span></span>
          </div>
      </div>
      <div class="p-banner">
        <ul>
          <li :style="'background-image: url('+o.bgUrl+')'"  v-for="o,index in fixPosPromoEntiy" :key="index">
            <div>
              <p>{{o.name}}<span class="t" v-show="o.betTimes">{{o.betTimes}}x</span></p>
              <p class="s">{{o.subName}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="games" v-show="sideMenusIndex!=-1" v-if="hotSlotGameList1[3]">
      <p><img :src="hotSlotGameList1[3].icon" />供应商</p>
      <dl>
        <dd @click="currentPlat=''" :class="{on:currentPlat===''}">所有</dd>
        <dd v-for="o,index in plats" :key="index" v-show="gameTypeAllGameList[0]&&gameTypeAllGameList[0].gameType==o.gameType" @click="currentPlat=o.game" :class="{on:currentPlat==o.game}">{{o.game}}</dd>
      </dl>
      <ul class="g">
        <li v-for="o,index in gameTypeAllGameList" :key="index" v-show="currentPlat===''||currentPlat==o.plat" @click="gameLoginAsync(o.id,o.plat)">
          <img :src="o.h5img" />
        </li>
      </ul>
    </div>
    <div class="games" v-if="hotSlotGameList1[3]" v-show="!$parent.userData.account">
      <p><img :src="hotSlotGameList1[3].icon" />{{hotSlotGameList1[3].categoryName}}</p>
      <ul class="h" ref="listWrap1">
        <li v-for="o,index in hotSlotGameList1[3].spreads" :key="index">
          <img :src="o.icon_url" />
          <span>{{o.title}}</span>
        </li>
      </ul>
      <span class="prev" @click="prev($refs.listWrap1)"></span>
      <span class="next" @click="next($refs.listWrap1)"></span>
    </div>
    <div class="games" v-if="hotSlotGameList1[0]" v-show="sideMenusIndex==-1">
      <p><img :src="hotSlotGameList1[0].icon" />{{hotSlotGameList1[0].categoryName}}</p>
      <ul class="g h" ref="listWrap2">
        <li v-for="o,index in hotSlotGameList1[0].games" :key="index" @click="gameLoginAsync(o.id,o.plat)">
          <img :src="o.logoUrl" />
        </li>
      </ul>
      <span class="prev" @click="prev($refs.listWrap2)"></span>
      <span class="next" @click="next($refs.listWrap2)"></span>
    </div>
    <div class="games" v-if="hotSlotGameList1[2]">
      <p><img :src="hotSlotGameList1[2].icon" />{{hotSlotGameList1[2].categoryName}}</p>
      <ul class="m h" ref="listWrap3">
        <li v-for="o,index in hotSlotGameList1[2].ranks" :key="index">
          <img :src="o.icon_url" />
        </li>
      </ul>
      <span class="prev" @click="prev($refs.listWrap3)"></span>
      <span class="next" @click="next($refs.listWrap3)"></span>
    </div>
    <div class="games" v-if="hotSlotGameList1[3]" v-show="$parent.userData.account">
      <p><img :src="hotSlotGameList1[3].icon" />{{hotSlotGameList1[3].categoryName}}</p>
      <ul class="h" ref="listWrap1">
        <li v-for="o,index in hotSlotGameList1[3].spreads" :key="index">
          <img :src="o.icon_url" />
          <span>{{o.title}}</span>
        </li>
      </ul>
      <span class="prev" @click="prev($refs.listWrap1)"></span>
      <span class="next" @click="next($refs.listWrap1)"></span>
    </div>
  </div>
</template>

<script>
import { qeuryHotSlotGameListVVINR,loadFixPosPromoEntiy_INR,queryGamesIe,qeuryAllGameListByGameType,queryPromosIe,gameLoginById } from '../api';

export default {
  name: 'GodBossHome',
  data() {
    return {
      gameList: [],
      hotSlotGameList1 : [],
      hotSlotGameList2 : [],
      hotSlotGameList3 : [],
      hostObj: {},
      fixPosPromoEntiy: [],
      sideMenus: [],
      sideMenusIndex: -1,
      currentIndexGameType: -1,
      plats: [],
      gameTypeAllGameList: [],
      promo: {
        menues: [],
        promos: []
      },
      banners: [],
      swiper: null,
      current: 0,
      currentPlat: ''
    }
  },
  created(){
    this.queryGamesAsync();
    this.qeuryHotSlotGameListVVINRAsync();
    this.loadFixPosPromoEntiy_INRAsync();
    this.queryPromosIeAsync();
  },
  mounted() {
  },
  methods: {
    async queryGamesAsync() {
      let result = await queryGamesIe();
      if (!result.Message) {
        this.sideMenus = result.Result.sideMenus;
        this.plats = result.Result.plats;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async qeuryHotSlotGameListVVINRAsync() {
      let result = await qeuryHotSlotGameListVVINR();
      if (!result.Message) {
        this.hotSlotGameList1 = result.Result;
       
        for(let o of this.hotSlotGameList1[0].games){
          this.$set(this.hostObj, o.id, true);
        }
      } else {
        this.$toast(result.Message);
      }
    },
    async loadFixPosPromoEntiy_INRAsync() {
      let result = await loadFixPosPromoEntiy_INR();
      if (!result.Message) {
        this.fixPosPromoEntiy = result.Result;
      } else {
        this.$toast(result.Message);
      }
    },  
    async qeuryAllGameListByGameTypeAsync(gameType) {
      let result = await qeuryAllGameListByGameType(gameType);
      if (!result.Message) {
        this.gameTypeAllGameList = result.Result;
      } else {
        this.$toast(result.Message);
      }
    },
    async queryPromosIeAsync() {
      let result = await queryPromosIe(0);
      if (!result.Message) {
        this.promo.menues = result.Result.promoMenues;
        this.promo.promos = result.Result.promoModels;

        let list = [];
        for (let o of result.Result.promoModels) {
          if (o.bannerStatus == 1) {
            list.push(o);
          }
        }

        this.banners = list.sort(this.sort);
      } else {
        this.$toast(result.Message);
      }
    },
    async gameLoginAsync(id,plat) {
      let tempWindow = window.open("","_blank");
      let result = await gameLoginById(
        id,
        plat
      );
      
      if (!result.Message) {
        if(result.Result.link.indexOf('<!DOCTYPE')==-1){
          tempWindow.location = result.Result.link;
          
        }else{
          tempWindow.document.write(result.Result.link);
          tempWindow.document.close();
        }
      } else {
        if (tempWindow != null) {
          tempWindow.close();
        }

        //this.showGameBox = false;
        this.$toast.fail(result.Message);
      }
    },
    next(o) {
      o.scrollTo({
        left: o.scrollLeft + 150,
        behavior: 'smooth'
      });
    },
    prev(o) {
      o.scrollTo({
        left: o.scrollLeft - 150,
        behavior: 'smooth'
      });
    },
    onSwipeChange(index){
      this.current=index;
    },
  } 
}
</script>

<style scoped>
.home .gr ul{
width:100%;
display:flex;
gap: 0.16rem;
align-items:center;
}

.home .gr ul li{
width:1.28rem;
height:0.56rem;
display:flex;
justify-content: center;
align-items: center;
cursor: pointer;
border-radius: 0.08rem;
gap:0.08rem;
background: #282828;
}

.home .gr ul li img{
display: block;
width:0.24rem;
height:0.24rem;
}

.home .gr ul li span{
display: block;
font-size: 0.2rem;
color:#ffffff;
}

.home .gr ul li.on{
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
border-radius:0.08rem;
font-weight: bold;
}
.banner{
  width:100%;
  display:flex;
  gap: 0.24rem;
  margin-top: 0.24rem;
}
.banner .m-banner{
  width:10.29rem;
  height:4.5rem;
  border-radius: 0.08rem;
  overflow: hidden;
  position: relative;
}

.banner .m-banner img{
width:10.29rem;
height:4.5rem;
}

.banner .m-banner .next{
width:1.12rem;
height:0.56rem;
display: flex;
align-items: center;
justify-content: space-between;
background: #202020;
border-radius: 0.16rem;
cursor: pointer;
position: absolute;
bottom: 0.24rem;
right: 0.24rem;
padding:0 0.08rem;
}

.banner .m-banner .next span{
display: block;
width:0.4rem;
height:0.4rem;
line-height:0.4rem;
text-align: center;
color:#ffffff;
font-size: 0.24rem;
font-weight: bold;
border-radius: 0.16rem;
}

.banner .m-banner .next span:first-child{
background: url('@/img/back.png') no-repeat center center #ffffff1a;
background-size: cover;
}

.banner .m-banner .next span:last-child{
background: url('@/img/right.png') no-repeat center center #ffffff1a;
background-size: cover;
}


/*@media screen and (max-width: 1366px) {
.home .gr ul{
  gap:0.16rem;
}
    .banner{
      gap:0.16rem;
    }
    .banner .m-banner{
      width:8.5rem;
      height:3.72rem;
    }

    .banner .m-banner img{
      width:100%;
      height:3.72rem;
    }
}*/

.banner .p-banner{
height:4.5rem;
}

.banner .p-banner ul{
  height:100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.24rem;
}
.banner .p-banner ul li{
width:7.39rem;
height: 2.13rem;
background-position: 100% 100%;
background-size: cover;
border-radius: 0.08rem;
background-repeat: no-repeat;
display: flex;
align-items: center;
padding-left:0.24rem;
}


.banner .p-banner ul li div{
height: 0.96rem;
display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.banner .p-banner ul li div p{
  font-size: 0.32rem;
  color:#ffffff;
  /* 仅文字周围发光，不要整块阴影 */
  text-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.7);
  font-weight: bold;
}

/*
@media screen and (max-width: 1366px) {
    .banner .p-banner{
      height:3.72rem;
    }

    .banner .p-banner ul{
      gap:0.16rem;
    }

    .banner .p-banner ul li{
      width:3.8035rem;
      height:1.76rem;
    }  
}*/

.games{
margin: 0.24rem 0;
position: relative;
}
.games p{
  display:flex;
  align-items: center;
  font-size: 0.2rem;
  font-weight: bold;
  
}
.games p img{
width:0.32rem;
height:0.32rem;
margin-right: 0.08rem;
}

.games ul{
display: flex;
flex-wrap: wrap;
margin-top:0.24rem;
gap: 0.24rem;
}

.games ul.g{
justify-content:flex-start;
gap: 0.24rem;
flex-wrap: wrap;
}

.games ul.h{
flex-wrap: nowrap;
overflow-x: auto;
scrollbar-width: none;
-ms-overflow-style: none;
}

.games ul.h::-webkit-scrollbar {
  display: none;
}

.games ul li{
cursor: pointer;
transition: all 0.3s ease;
position: relative;
}

.games ul.g li{
}

.games ul li:hover{
transform: scale(1.05);
}
.games ul li img{
width:4.3rem;
height:2rem;
border-radius: 0.16rem;
}

.games ul.g li img{
width:2.03rem;
height:2.03rem;
border-radius: 0.08rem;
}

.games ul li span{    
position: absolute;
top:50%;
margin-top:-0.12rem;
left: 0.24rem;
font-size: 0.24rem;
font-weight: bold;
}

.games ul.m li img{
border-radius: 0.08rem;
}

.games dl{
display: flex;
gap: 0.08rem;
margin-top: 0.24rem;
}

.games dl dd{
width: 1.08rem;
height: 0.37rem;
line-height: 0.37rem;
text-align: center;
font-size: 0.14rem;
font-weight: 600;
background: #202020;
border-radius: 0.08rem;
cursor: pointer;
}

.games dl dd.on{
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
}

.games .prev{
width: 0.48rem;
height: 0.48rem;
background: url('@/img/back.png') no-repeat center center;
background-size: contain;
cursor: pointer;
position: absolute;
left: 0;
top: 50%;
}

.games .next{
width: 0.48rem;
height: 0.48rem;
background: url('@/img/right.png') no-repeat center center;
background-size: contain;
cursor: pointer;
position: absolute;
right: 0;
top: 50%;
}

/*@media screen and (max-width: 1366px) {
    .games ul{
      gap: 0.16rem;
    }

    .games ul li img{
      width:2.98rem;
      height:1.36rem;
    }
    .games ul.g{
      gap: 0.16rem;
      max-width: 12.38rem;
    }

    .games ul.g li img{
      width:1.6314rem;
      height:1.6314rem;
    }
    
}*/

/* ===== responsive overrides start (safe to delete) ===== */

@media screen and (max-width: 1600px) {
  .banner {
    gap: 0.24rem;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 8.5rem;
    height: 3.72rem;
  }

  .banner .p-banner {
    height: 3.72rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
  }

  .banner .p-banner ul li {
    width: 6.1rem;
    height: 1.76rem;
  }

  .games ul {
    gap: 0.24rem;
  }

  .games ul li img {
    width: 3.5rem;
    height: 1.6rem;
  }

  .games ul.g {
    gap: 0.24rem;
  }

  .games ul.g li img {
    width: 1.63rem;
    height: 1.63rem;
  }
}

@media screen and (max-width: 1366px) {
  .banner {
    gap: 0.16rem;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 8.5rem;
    height: 3.72rem;
  }

  .banner .p-banner {
    height: 3.72rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
  }

  .banner .p-banner ul li {
    width: 3.8035rem;
    height: 1.76rem;
  }

  .games ul {
    gap: 0.16rem;
  }

  .games ul li img {
    width: 2.98rem;
    height: 1.36rem;
  }

  .games ul.g {
    gap: 0.16rem;
  }

  .games ul.g li img {
    width: 1.6314rem;
    height: 1.6314rem;
  }
}

@media screen and (max-width: 1024px) {
  .home .gr ul li{
    width:0.96rem;
  }

  .banner {
    gap: 0.16rem;
     flex-wrap: wrap;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 9.12rem;
    height: 4rem;
  }

  .banner .p-banner {
    height: 1.76rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
    flex-direction: row;
  }

  .banner .p-banner ul li {
    width: 4.48rem;
    height: 1.76rem;
  }

  .games ul {
    gap: 0.16rem;
  }

  .games ul li img {
    width: 4.48rem;
    height: 1.76rem;
  }

  .games ul.g {
    gap: 0.16rem;
  }

  .games ul.g li img {
    width: 1.64rem;
    height: 1.64rem;
  }
}

@media screen and (max-width: 820px) {
.home .gr ul{
  gap: 0.08rem;
}
  .home .gr ul li{
    width:0.88rem;
  }

  .banner {
    gap: 0.16rem;
     flex-wrap: wrap;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 7.08rem;
    height: 3.4461rem;
  }

  .banner .p-banner {
    height: 1.76rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
    flex-direction: row;
  }

  .banner .p-banner ul li {
    width: 3.46rem;
    height: 1.46rem;
  }

  .games ul {
    gap: 0.16rem;
  }

  .games ul li img {
    width: 3.46rem;
    height: 1.46rem;
  }

  .games ul.g {
    gap: 0.16rem;
  }

  .games ul.g li img {
    width: 1.64rem;
    height: 1.64rem;
  }
}

@media screen and (max-width: 768px) {


  .banner {
    gap: 0.16rem;
     flex-wrap: wrap;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 6.66rem;
    height: 3.3578rem;
  }

  .banner .p-banner {
    height: 1.76rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
    flex-direction: row;
  }

  .banner .p-banner ul li {
    width: 3.25rem;
    height: 1.4rem;
  }

  .games ul {
    gap: 0.16rem;
  }

  .games ul li img {
    width: 3.25rem;
    height: 1.4rem;
  }

  .games ul.g {
    gap: 0.16rem;
  }

  .games ul.g li img {
    width: 1.2rem;
    height: 1.2rem;
  }
}
/* ===== responsive overrides end (safe to delete) ===== */

</style>

